import {DefectDataItem} from "../../types/DefectsDataItem";
import {useTranslation} from "react-i18next";
import { useRef, useState } from "react";
import ImageViewer, {ImageViewerMethods} from "../Shared/ImageViewer";
import { assetsUrlsRequest } from "../../services/AssetsService";
import {errorToast} from "@idwal/idwal-react-components";
import {MenuButton} from "../MenuButton/MenuButton";
import {navigateToRectificationView} from "../../utils/DefectRectificationHelpers";
import {RECTIFICATIONS} from "../../types/RouteNames";
import {useNavigate} from "react-router-dom";
import { sendGAEvent } from "../../AnalyticsService";
import { ANALYTICS_BUTTON_CLICK, DEFECTS_ACTIONS_VIEW_DEFECT_CLICK, DEFECTS_ACTIONS_VIEW_IMAGES_CLICK } from "../../constants/analytics";
import { useAppSelector } from "../../hooks/storeHooks";
import { selectSharedDefects } from "../../store/selectors/sharedDefectsSelectors";

export const SharedDefectActionMenu = (data: DefectDataItem) => {
    const {t} = useTranslation("locale");
    const { data: sharedDefects } = useAppSelector(selectSharedDefects);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const imageViewerRef = useRef<ImageViewerMethods | null>(null);

    const handleImageClick = async () => {
        if (loading) {
            return;
        }
        const images = JSON.parse(data.images);
        const assetIds = images.map((asset: any) => asset?.Id);
        setLoading(true);
        await assetsUrlsRequest(assetIds)
            .then(signedUrlsResponse => {
                if (signedUrlsResponse?.length) {
                    const signedUrls = signedUrlsResponse.map((asset: any) => Object.values(asset)[0]);
                    if (imageViewerRef.current) {
                        imageViewerRef.current.handleImageClick(signedUrls);
                    }
                } else {
                    errorToast(t("imageViewer.errorMessage"))
                }
            })
            .catch(error => {
                errorToast(t("imageViewer.errorMessage"));
            });
        setLoading(false);
    }

    let menuItems = [
        {
            label: t("menuButton.viewDefect"),
            icon: <img className="pr-2" alt="view_defect" src="./view-defect-menu.svg"></img>,
            command: () => {
                navigateToRectificationView(sharedDefects, data.defectId, navigate, RECTIFICATIONS);
                sendGAEvent(ANALYTICS_BUTTON_CLICK, DEFECTS_ACTIONS_VIEW_DEFECT_CLICK);
            }
        },
    ];

    if (!(data.images === null || data.images === "" || data.images === "[]" || data.images === "null")) {
        menuItems.push({
            label: t("menuButton.viewImages"),
            icon: <img className="pr-2" alt="request_inspection" src="./view-images-menu.svg"></img>,
            command: () => {
                handleImageClick().then(r => {
                });
                sendGAEvent(ANALYTICS_BUTTON_CLICK, DEFECTS_ACTIONS_VIEW_IMAGES_CLICK);
            }
        })
    }

    return (
        <div className="flex align-items-center justify-content-center">
            <ImageViewer ref={imageViewerRef}/>
            <MenuButton menu={menuItems}/>
        </div>
    )
}
